import { render, staticRenderFns } from "./Onboard-Page.vue?vue&type=template&id=207874a9&scoped=true&"
import script from "./Onboard-Page.vue?vue&type=script&lang=js&"
export * from "./Onboard-Page.vue?vue&type=script&lang=js&"
import style0 from "./Onboard-Page.vue?vue&type=style&index=0&id=207874a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207874a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
